import React from 'react';
import { useTranslation } from 'react-i18next';

const pad = (n) => String(n).padStart(2, '0');
const formatCallTime = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

const Header = ({ headerTitle, callSeconds = 0, participantCount = 1, onInvite }) => {
  const { t } = useTranslation();
  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 20px', height: 56,
      background: '#ffffff',
      borderBottom: '1px solid #e2e8f0',
      flexShrink: 0,
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      position: 'relative', zIndex: 10,
    }}>
      {/* Left */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: '#1e293b' }}>{headerTitle}</span>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 4,
          padding: '3px 10px', borderRadius: 20,
          background: '#fdf2f4', border: '1px solid #f5c6ce',
          fontSize: 11, fontWeight: 600, color: '#800020',
        }}>
          🔒 {t('screens.video.group.e2eEncrypted')}
        </div>
      </div>

      {/* Center */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{
          fontSize: 14, fontWeight: 700, color: '#1e293b',
          fontVariantNumeric: 'tabular-nums', letterSpacing: '0.5px',
        }}>
          {formatCallTime(callSeconds)}
        </span>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '3px 10px', borderRadius: 20,
          background: '#ecfdf5', border: '1px solid #a7f3d0',
          fontSize: 11.5, fontWeight: 700, color: '#065f46',
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: '50%', background: '#10b981',
            animation: 'livePulse 2s infinite',
          }} />
          {t('screens.video.group.live')}
        </div>
      </div>

      {/* Right */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '5px 12px', borderRadius: 8,
          background: '#f8fafc', border: '1px solid #e2e8f0',
          fontSize: 12.5, fontWeight: 600, color: '#475569',
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="7" r="4" />
            <path d="M3 21v-2a4 4 0 014-4h4" />
            <circle cx="17" cy="12" r="3" />
            <path d="M21 21v-1a3 3 0 00-3-3h-2a3 3 0 00-3 3v1" />
          </svg>
          {participantCount}
        </div>
        {onInvite && (
          <button
            onClick={onInvite}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '6px 14px', borderRadius: 8,
              background: '#800020', border: 'none', color: '#fff',
              fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            {t('screens.video.group.inviteBtn')}
          </button>
        )}
      </div>

      <style>{`
        @keyframes livePulse {
          0%,100% { opacity:1; transform:scale(1); }
          50% { opacity:0.6; transform:scale(0.85); }
        }
      `}</style>
    </header>
  );
};

export default Header;
